import React from 'react'
import styles from './LegacyAppMovedNotice.module.sass'

const APP_STORE_URL = 'https://apps.apple.com/ae/app/bso-club/id6443900509'
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=ae.bso.twa'

export default function LegacyAppMovedNotice(): JSX.Element {
    return (
        <main className={styles.page}>
            <section className={styles.card} aria-labelledby="legacy-app-moved-title">
                <div className={styles.logoWrap}>
                    <img className={styles.logo} src="/assets/media/logo512.png" alt="BSO Club" />
                </div>

                <p className={styles.eyebrow}>BSO Club</p>
                <h1 id="legacy-app-moved-title" className={styles.title}>This version is no longer available</h1>
                <p className={styles.subtitle}>BSO has moved this experience to the mobile app.</p>
                <p className={styles.body}>
                    For a faster, safer, and more reliable experience, please continue using BSO through our latest mobile application. Your account and service requests remain available there.
                </p>

                <div className={styles.actions} aria-label="Download BSO Club mobile app">
                    <a className={styles.storeLink} href={APP_STORE_URL} target="_blank" rel="noreferrer">
                        <span className={styles.storeKicker}>Download on the</span>
                        <span className={styles.storeName}>App Store</span>
                    </a>
                    <a className={styles.storeLink} href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer">
                        <span className={styles.storeKicker}>Get it on</span>
                        <span className={styles.storeName}>Google Play</span>
                    </a>
                </div>

                <div className={styles.support}>
                    <a href="tel:+971526477228">+971 52 647 7228</a>
                    <span aria-hidden="true">|</span>
                    <a href="mailto:brokers@bso.ae">brokers@bso.ae</a>
                </div>

                <p className={styles.footer}>If you need any help, please contact BSO support.</p>
            </section>
        </main>
    )
}
